import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import About from "./views/About.vue";
import Privacypolicy from "./views/privacypolicy.vue";
import PrivacypolicyCn from "./views/privacypolicycn.vue";
import SubPage from "./views/SubViewPage.vue";

Vue.use(Router);

export default new Router({
  // mode: "history",
  base: process.env.BASE_URL,
  // base: './',
  routes: [
    {
      path: "/",
      name: "home",
      alias: ["/index.html"],
      component: Home
    },
    {
      path: "/info/:type/:name",
      name: "info",
      component: SubPage,
      props: true
    },
    {
      path: "/about",
      name: "about",
      component: About
      // component: () =>
      //   import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/privacypolicy/:name",
      name: "privacypolicy",
      component: Privacypolicy,
      props: true
      // component: () => import("./views/privacypolicy.vue")
      // component: () =>
      //   import("./views/About.vue")
    },
    {
      path: "/privacypolicycn/:name",
      name: "privacypolicycn",
      component: PrivacypolicyCn,
      props: true
      // component: () => import("./views/privacypolicycn.vue")
      // component: () =>
      //   import("./views/About.vue")
    },
    {
      path: "*",
      name: "error",
      component: Home
    }
  ]
});

